import { useState } from "react";
import FolderPanel from "../components/mail/FolderPanel";
import EmailListPanel from "../components/mail/EmailListPanel";
import EmailContentPanel from "../components/mail/EmailContentPanel";
import ComposeButton from "../components/mail/ComposeButton";
import { useEmailStore } from "../stores/emailStore";

interface MailLayoutProps {
  onComposeOpen: () => void;
  onReply: () => void;
  onReplyAll: () => void;
  onForward: () => void;
  onEditDraft: (draftEmail: any) => void;
}

export default function MailLayout({ onComposeOpen, onReply, onReplyAll, onForward, onEditDraft }: MailLayoutProps) {
  const [isFolderDrawerOpen, setIsFolderDrawerOpen] = useState(false);
  const currentEmail = useEmailStore((s) => s.currentEmail);

  return (
    <div className="flex h-full h-[100dvh] w-full overflow-hidden bg-[var(--bg-primary)]">
      {/* Folder sidebar (responsive drawer on mobile) */}
      <FolderPanel
        isOpenMobile={isFolderDrawerOpen}
        onCloseMobile={() => setIsFolderDrawerOpen(false)}
        onCompose={onComposeOpen}
      />

      <div className="flex flex-1 min-w-0 h-full overflow-hidden">
        {/* Email list: full width on mobile when no email selected, side-by-side on lg */}
        <div
          className={`h-full min-w-0 overflow-hidden ${
            currentEmail ? "hidden lg:flex lg:w-[350px] lg:min-w-[350px] lg:flex-none" : "flex flex-1 w-full max-w-full lg:w-[350px] lg:min-w-[350px] lg:max-w-[400px] lg:flex-none"
          }`}
        >
          <EmailListPanel onOpenFolderDrawer={() => setIsFolderDrawerOpen(true)} onOpenDraft={onEditDraft} />
        </div>

        {/* Email content: full width on mobile when email selected, side-by-side on lg */}
        <div
          className={`h-full ${
            currentEmail ? "flex flex-1 min-w-0" : "hidden lg:flex lg:flex-1 min-w-0"
          }`}
        >
          <EmailContentPanel onReply={onReply} onReplyAll={onReplyAll} onForward={onForward} onEditDraft={onEditDraft} />
        </div>
      </div>

      {/* Floating button visible on mobile when no email is currently open */}
      <div className="lg:hidden">
        {!currentEmail && <ComposeButton onClick={onComposeOpen} />}
      </div>
    </div>
  );
}
